import { Component, Inject, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AppMs13Service } from "app/business/service/app/app-ms13.service";
import { map, Observable, startWith } from "rxjs";
import { SubDistrictSelectionDialogComponent } from "../sub-district-selection-dialog/sub-district-selection-dialog.component";

@Component({
  selector: "app-survey-location-dialog",
  templateUrl: "./survey-location-dialog.component.html",
  styleUrls: ["./survey-location-dialog.component.css"],
})
export class SurveyLocationDialogComponent implements OnInit {
  form: any = {};
  inspectLocationSearch = new FormControl();
  filteredOptionsInspectLocation$: Observable<string[]>;
  surveyLocationList: any = [];
  userProfile: any = JSON.parse(localStorage.getItem("userProfile"));
  selectedItem: boolean = false;

  constructor(
    public appMs13Service: AppMs13Service,
    public dialogRef: MatDialogRef<SurveyLocationDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.form = data;
    }
  }

  async ngOnInit() {
    var rqSurveyLocation = {
      cpid: Number(this.userProfile.cpId),
    };

    await this.appMs13Service
      .getMs13SurveyLocationHistory(rqSurveyLocation)
      .then((res) => {
        if (res === "error") {
          this.surveyLocationList = [];
          return;
        } else {
          this.surveyLocationList = res;
        }
      });

    this.filteredOptionsInspectLocation$ =
      this.inspectLocationSearch.valueChanges.pipe(
        startWith(""),
        map((value) => {
          const name = typeof value === "string" ? value : value?.name;
          return name
            ? this.filterSurveyLocation(name as string)
            : this.surveyLocationList.slice();
        })
      );

    if (this.form.locationName) {
      var inspectLocationSearch = this.surveyLocationList.find((e) =>
        e.surveyLocationName.includes(this.form.locationName)
      );
      if (inspectLocationSearch != undefined && inspectLocationSearch != null) {
        this.inspectLocationSearch.patchValue(inspectLocationSearch);
        this.selectedItem = true;
      }
    }
  }

  public filterSurveyLocation(search: any) {
    console.log(search);
    const filterValue = search.toLowerCase();

    return this.surveyLocationList.filter(function (option) {
      if (option.surveyLocationName.includes(filterValue)) {
        return option;
      }
    });
  }

  displayInspectLocation(inspect): string {
    return inspect && inspect.surveyLocationName
      ? `${inspect.surveyLocationName}`
      : "";
  }

  selectSubdistrict() {
    this.dialog
      .open(SubDistrictSelectionDialogComponent, {
        disableClose: false,
        width: "50vw",
      })
      .afterClosed()
      .subscribe((res) => {
        if (res != undefined && res != null) {
          this.form.subDistrict = res.subdistrictName;
          this.form.district = res.districtName;
          this.form.province = res.provinceName;
          this.form.postCode = res.postalCode;
        }
      });
  }

  selectionInspectLocationChange(e): void {
    this.form.locationName = e.option.value.surveyLocationName.trim();
    this.form.address = e.option.value.surveyAddress.trim();
    this.form.subDistrict = e.option.value.surveyDistrict.trim();
    this.form.district = e.option.value.surveySubProvince.trim();
    this.form.province = e.option.value.surveyProvince.trim();
    this.form.postCode = e.option.value.surveyPostCode.trim();
    this.selectedItem = true;
  }

  cancelItem() {
    this.inspectLocationSearch.setValue("");
    this.form.locationName = "";
    this.form.address = "";
    this.form.subDistrict = "";
    this.form.district = "";
    this.form.province = "";
    this.form.postCode = "";

    this.selectedItem = false;
  }

  checkOptionValue(e) {
    if (typeof e === "object") {
      return e?.surveyLocationName;
    } else {
      return e;
    }
  }

  onChange(e) {
    if (e.checked == true) {
      this.form.isMain = "Y";
    } else {
      this.form.isMain = "N";
    }
  }

  endPopup(e) {
    if (e == "save") {
      if (!this.selectedItem) {
        this.form.locationName = this.checkOptionValue(
          this.inspectLocationSearch.value
        );
      }
      this.form.isMain = this.form.isMain ?? "N";

      this.dialogRef.close(this.form);
    } else {
      this.dialogRef.close(undefined);
    }
  }
}
